import { Modal } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import { useState } from "react";
import Back from "../../../../assets/back-icon.svg";
import { useAppSelector } from "customHooks/useAppSelector";
import DOMPurify from 'dompurify';

const MerchantsVehicleTermsAndCondition = (props: any) => {
  const [confirm, setConfirm] = useState(false);
  const [accept, setAccept] = useState(false);

  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
    checkbox2: false,
  });

  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    setCheckboxes({
      ...checkboxes,
      [name]: checked,
    });
  };
  const vehicleData = useAppSelector(
    (state) => state?.vehicleFinance?.vehicleInfo
  );

  const isButtonDisabled = !checkboxes.checkbox1;
  const sanitizedTerms = DOMPurify.sanitize(vehicleData?.TandCUrl || '');
  const sanitizedHtmlTerms = DOMPurify.sanitize(vehicleData?.Terms || '');

  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={500}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      // className="parent"
      >
        <div
          style={{
            cursor: "pointer",
            paddingLeft: "1em",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
          }}
        >
          <img
            onClick={props.goBackToSummary}
            src={Back}
            className={Styles.backIcon}
            alt="back"
          />
        </div>
        <div
          className={Styles.modalContentVerification}
          style={{ maxHeight: "70vh", overflow: "scroll", paddingTop: "0em" }}
        >
          <div
            style={{ fontSize: "1.18em", fontWeight: "bold", color: "#003883" }}
            className={Styles.title}
          >
            Terms and Conditions
          </div>
          {/* <div style={{ fontSize: "1em" }} className={Styles.descThree}>
            Vehicle Finance Loan Terms and Condition
          </div> */}
          {/* <div style={{ paddingTop: "1em" }} className={Styles.descThree}>
            Further to your application for a credit facility, we are pleased to
            inform you that the Management of Access Bank Plc (the “Lender” or
            “Bank”) has approved a time loan (“facility”) under the following
            terms and conditions:
          </div> */}

          {/* <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              Amount
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              {" "}
              As may be approved by Access Bank.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              PURPOSE
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              To offer finance to eligible salary customers for the purchase of
              devices.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              TENOR
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              180 days.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              INTEREST
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The interest rate for the facility is 10% monthly on the reducing
              principal balance, which shall be subject to review from
              time-to-time in line with the prevailing money market condition.
              Any change in pricing of the facility notified by the Lender to
              the Borrower shall be binding on the Borrower.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              MANAGEMENT FEE{" "}
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              1% flat.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              ADVISORY FEE{" "}
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              1% flat.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              CREDIT LIFE INSURANCE (Fire and burglary inclusive)
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              0.9% flat.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              PENAL CHARGE - 1%
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              REPAYMENT SOURCE
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              Proceeds from inflow into the customer’s account. By accepting
              these Terms and Conditions, I authorize a debit to my account and
              where unfunded, any BVN account in Access and/or other banks
              should be debited for repayment.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              COMMENCEMENT DATE
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              This facility shall commence upon drawdown or on the date of
              disbursement notwithstanding the date on the offer or date of
              execution. This loan is repayable on three (3) monthly repayment
              instalments.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              COOLING OFF PERIOD
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The borrower agrees to waive 3-days cooling off period to enable
              disbursement.{" "}
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              SECURITY/SUPPORT
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The facility shall be secured with the following:{" "}
            </div>
            <ul>
              <li className={Styles.descThree}>
                Personal Guarantee of the promoter of the business or the
                majority shareholder of the Borrower, with the notarized
                Statement of Net worth.{" "}
              </li>
              <li className={Styles.descThree}>
                Irrevocable letter of lien/set off from related accounts of
                sister companies or individual accounts of the promoters of the
                Borrower.
              </li>
              <li className={Styles.descThree}>
                Irrevocable Direct Debit Mandate, to the Bank, to pool any funds
                in the accounts linked to the promoters’ Bank Verification
                Number (BVN).
              </li>
            </ul>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              AVAILABILITY
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              This facility shall be available for utilization only upon
              satisfactory compliance with the conditions precedent to drawdown
              as may be prescribed by Access Bank.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              DISBURSEMENT
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              Loans are usually disbursed instantly, however in some cases,
              delays are caused by third parties outside the control of Access
              Bank. Such delays are generally resolved within 24 hours and we
              will keep you informed as to when your loan will disburse.{" "}
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              Conditions Precedents to Draw Down:
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                An active account with at least 3 months consistent monthly
                turnover
              </li>
              <li className={Styles.descThree}>Duly executed offer letter. </li>
              <li className={Styles.descThree}>
                Board Resolution of the Borrower accepting the facility and
                naming the officers authorized to execute documents on its
                behalf (for body corporate).
              </li>
              <li className={Styles.descThree}>
                Certified true copies of the incorporation documents of the body
                corporate.
              </li>
              <li className={Styles.descThree}>
                Personal Guarantee of the promoter of the business or the
                majority shareholder of the Borrower, with the notarized
                Statement of Net worth.
              </li>
              <li className={Styles.descThree}>
                Acceptable means of identification of the promoters or majority
                shareholders.{" "}
              </li>
              <li className={Styles.descThree}>
                Irrevocable letter of lien/set off from related accounts of
                sister companies or individual accounts of the promoters of the
                Borrower, in form and substance acceptable to the Bank,
                supported by the Board Resolutions (where the related account is
                a corporate entity).
              </li>
              <li className={Styles.descThree}>
                Irrevocable Direct Debit Mandate, to the Bank, to pool any funds
                in the accounts linked to the promoters’ BVN, in form and
                substance acceptable to the Bank and supported by the duly
                certified statement of account from its accounts with other
                banks.{" "}
              </li>
              <li className={Styles.descThree}>
                Receipt of duly executed advisory mandate agreement
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              Other Conditions:
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                If the Borrower fails to utilize the facility for the purpose
                for which it was granted.{" "}
              </li>
              <li className={Styles.descThree}>
                If the Borrower diverts any lodgement meant for the Borrower’s
                account with the Lender to another Bank.
              </li>
              <li className={Styles.descThree}>
                If the Borrower shall commit any breach or fail to observe or
                perform the other obligations on its part as contained in this
                offer letter or fails to keep to the agreed repayment terms.{" "}
              </li>
              <li className={Styles.descThree}>
                If it is discovered that there was a material misrepresentation
                of facts by the Borrower with regards to the purpose,
                utilization of the facility and the collateral.
              </li>
              <li className={Styles.descThree}>
                If the value of the collateral has depreciated
                disproportionately relative to the facility amount at any
                material time.{" "}
              </li>
              <li className={Styles.descThree}>
                The Lender shall provide a pool of at least three professional
                valuers (for the Borrower to choose one) to conduct annual
                re-evaluation of any collateral pledged by the Borrower. The
                cost of such re-evaluation shall be debited to the Borrower’s
                account with the Lender. Where the re-evaluation reveals a
                diminution on the value of the asset leading to under
                collateralisation of the facility, the Lender may issue the
                Borrower a demand notice to provide additional collateral to
                cover the facility. Failure by the Borrower to Lender may upon
                ten (10) days’ notice to the Borrower, vary some or all the
                terms and conditions of the offer to reflect the prevailing
                conditions in the financial markets or monetary authorities
                regulations{" "}
              </li>
              <li className={Styles.descThree}>
                If any interest due on the facility is not paid on the date
                thereof, same shall immediately be added to the principal sum
                outstanding and shall accordingly attract interest at the rate
                herein stated.{" "}
              </li>
              <li className={Styles.descThree}>
                Where this facility is subject possible exchange rate risk, this
                risk shall remain the primary obligation of the customer at all
                times. There is no obligation on the part of the Bank to provide
                the customer with funds (either in local or foreign currency) to
                repay any exposure from the utilization of this facility.{" "}
              </li>
              <li className={Styles.descThree}>
                Availability of funds is subject to the Bank’s ability to
                accommodate this facility within its legal lending limits and
                subject further to regulations as may be imposed by regulatory
                authorities.
              </li>
              <li className={Styles.descThree}>
                The renewal of the facility shall be subject to the Bank being
                satisfied that the facility was properly utilized and
                liquidated.{" "}
              </li>
              <li className={Styles.descThree}>
                provide such additional collateral as requested by the Lender
                shall constitute an event of default under this facility
                entitling the Lender to call in the facility notwithstanding the
                tenor stated herein.
              </li>
              <li className={Styles.descThree}>
                The Lender reserves the right at any time to convert this
                facility to overdraft, advances, commercial papers and other
                money market instruments available to the Lender.
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              COVENANTS
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower hereby covenants with the Lender that the account
              would be sufficiently funded up-front to absorb interest,
              commission and other charges.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower hereby covenants with the Lender that the account
              would be domiciled in the Bank, as long as the Borrower has an
              active exposure or have outstanding balance on principal or
              interest.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              By signing this offer letter/loan agreement and by drawing on the
              loan, the Borrower covenants to repay the facility as and when
              due. In the event that the Borrower fails to repay the facility as
              agreed, and the loan becomes delinquent, the Bank shall have the
              right to report the delinquent loan to the CBN through the Credit
              Risk Management System (CRMS) or by any means, and request the CBN
              to exercise its regulatory power to direct all Banks and other
              financial institutions under its regulatory purview to set-off the
              borrower’s indebtedness from any money standing to the borrower’s
              credit in any bank account and from any money standing to the
              borrower’s credit in any bank account and from any other financial
              assets they may be holding for the borrower’s benefit.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              EARLY LIQUIDATION
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower is at liberty to pay off their loan before maturity
              date at their convenience, using any of the Bank’s digital lending
              channels, or by visiting any Access Bank branch at no additional
              cost to the Borrower.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              Loans will be liquidated on a reducing balance, where the monthly
              interest repayment amount will decrease over time as the balance
              is paid down. Interest repayment is on a monthly basis, where the
              Borrower will be charged against the full monthly cycle.{" "}
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              EVENTS OF DEFAULT
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              Notwithstanding anything herein before contained, the facility or
              balance thereof and other monies herein covenanted to be paid
              whether by way of interest or otherwise shall become immediately
              due and payable on the demand being made in respect of such on the
              occurrence of any of the following events:
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                If the Borrower shall fail to pay any sum outstanding as and
                when due.
              </li>
              <li className={Styles.descThree}>
                If the Borrower commits any breach or fail to observe or perform
                the other obligations.{" "}
              </li>
              <li className={Styles.descThree}>
                If any representation or warranty given or made by the Borrower
                in this Agreement or in any notice or certificate or statement,
                delivered or made pursuant herein is inaccurate in any respect
                when made or delivered.{" "}
              </li>
              <li className={Styles.descThree}>
                If the Borrower stops or suspends or is deemed to be unable to
                pay its debt or admits in writing its inability to discharge its
                obligations.{" "}
              </li>
              <li className={Styles.descThree}>
                If the Borrower proposes or declares any moratorium on the
                Borrower's debt in respect of the facility.
              </li>
              <li className={Styles.descThree}>
                If any extra-ordinary situation arises such that the continuance
                of the transaction in the opinion of the Lender makes it
                impossible for the Borrower to discharge its obligations.
              </li>
              <li className={Styles.descThree}>
                If Access Bank shall be compelled by any Central Bank of
                Nigeria's rules, regulations or directives to call the facility.{" "}
              </li>
              <li className={Styles.descThree}>
                If there should in the opinion of Access Bank be a material
                adverse change in the financial condition of the Borrower.
              </li>
              <li className={Styles.descThree}>
                If any government consent required by law for the validity,
                enforceability or legality of this offer or the performance of
                the terms thereof ceases to be or is not for any reason in full
                force and effect. In any such event and at any time thereafter
                if any such event shall be continuing, Access Bank shall by
                written notice to the Borrower, declare that, that portion of
                the facility outstanding has become immediately payable
                whereupon the same shall become so payable together with
                interest accrued thereon.{" "}
              </li>
              <li className={Styles.descThree}>
                If any execution or distress is levied upon or against the
                properties of the Borrower and not discharged within seven days.{" "}
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              RIGHT OF SET-OFF
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower covenants that in addition to any general lien or
              similar right to which the Lender as a banker may be entitled by
              law, the Lender may at any time and without notice to the Borrower
              combine or consolidate all or any of the Borrower's accounts with
              any liabilities to the Lender and set off or transfer any sum or
              sums standing to the credit of anyone or more of such accounts in
              or towards satisfaction of the Borrower's liabilities to the
              Lender, or any other respect whether such liabilities be actual or
              contingent, primary or collateral and several or joint.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower covenants and warrants that the CBN shall have power
              to set-off its indebtedness under this loan agreement from all
              such monies and funds standing to its credit/benefit in any and
              all such accounts or from any other financial assets belonging to
              it and in custody of any such bank.{" "}
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              RIGHT OF CONFIDENTIALITY
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower hereby waives any right of confidentiality whether
              arising under common law or statute or in any other manner
              whatsoever and irrevocably agrees that it shall not argue to the
              contrary before any court of law, tribunal, administrative
              authority or any other body acting in any judicial or
              quasi-judicial capacity.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              LEGAL AND OTHER EXPENSES
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower shall reimburse Access Bank for all reasonable out of
              pocket expenses, costs, and charges incurred by Access Bank in
              connection with the preparation, execution, administration and
              enforcement of the terms of this offer, including but not limited
              to Solicitors fees, Stamp Duties and Registration fees. Such
              charges and costs shall in the event of non-payment by the
              Borrower on demand be added to the facility and other moneys owing
              under the terms of this offer and shall bear interest accordingly.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              INSURANCE
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower shall maintain a credit life insurance policy against
              loss of life and such other risks as Access Bank may from time to
              time consider necessary in an Insurance Company approved by Access
              Bank. The Borrower shall duly pay all premiums for keeping such
              insurance. The Bank's interest as first loss payee must be duly
              endorsed on the insurance policy.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              TAXES
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              All payments whether of principal, interest or otherwise shall be
              made free and clear of and without deduction of any taxes, duties,
              charges, fees, deductions, withholdings, set offs, counterclaims,
              restrictions or conditions of any nature. If at any time,
              provision of the law or any taxing authority shall require the
              Borrower to make any such deduction or withholding from any such
              payment, then the sum due from the Borrower in respect of such
              payment shall be increased to the extent necessary to ensure that
              after making of such deductions or withholding, Access Bank
              receives a net equal to the sum which it would have received had
              no such deduction or withholding been required to be made.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              REPRESENTATIONS AND WARRANTIES
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower hereby irrevocably and unconditionally represents and
              warrants that:
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                The Borrower has the right to accept this facility and has taken
                all necessary actions to authorise same upon the terms and
                conditions herein.
              </li>
              <li className={Styles.descThree}>
                The Borrower is not in default or under any obligation in
                respect of any borrowed money, and that the acceptance of this
                facility will not be or result in a breach of or default under
                any provisions of any other agreement to which the Borrower is a
                party.
              </li>
              <li className={Styles.descThree}>
                It is agreed that the facility herein granted shall be cancelled
                and the outstanding sums shall become payable forthwith upon
                demand thereof if any event or series of events (including
                without limitation, any material adverse change on the financial
                condition of the Borrower) occurs, which in the opinion of the
                Lender may affect the ability or willingness of the Borrower to
                repay the facility.
              </li>
              <li className={Styles.descThree}>
                All information given to Access Bank is true, correct, complete
                and not misleading.
              </li>
              <li className={Styles.descThree}>
                There are no pending or threatened actions or proceedings
                affecting the Borrower before any court or other body which may
                adversely affect the Borrower’s ability to perform and observe
                its obligations on this facility.
              </li>
              <li className={Styles.descThree}>
                The Borrower is not in default under any other agreement
                relating to indebtedness.
              </li>
              <li className={Styles.descThree}>
                No part of this facility will be used to pay amounts owing to
                Access Bank or any entity or person related to the Bank under
                another credit arrangement, without the consent of the Bank in
                writing.
              </li>
              <li className={Styles.descThree}>
                No legal action shall be instituted howsoever, instigated and/or
                sustained by the Borrower against the Lender jointly or
                severally without first giving the Lender a ninety day prior
                written pre-action notice of the Borrower’s intention to so
                proceed against the Lender, such notice to be served at the
                Lender’s registered office address.
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              CHANGE IN CIRCUMSTANCE
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              If the Lender has determined that the introduction of or change in
              any applicable law or government or other regulatory authority
              charged with the administration thereof or court of competent
              jurisdiction makes it apparent that it is unlawful or illegal for
              the Borrower or the Lender to fund or maintain or perform their
              obligations as contemplated by the terms of this Offer Letter, the
              Lender shall forthwith give notice of such occurrence to the
              Borrower and the commitment shall forthwith be cancelled or
              discharged and the Borrower shall on the next succeeding payment
              date or such earlier date as may be required repay to the Lender
              the principal amount so disbursed together with accrued interest,
              if any, and other amount due to the Lender hereunder.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              REMEDIES AND WAIVERS
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              Failure or delay by the Lender in exercising any remedy, power or
              right as a Lender shall not be considered as a waiver or
              impairment thereof nor shall it affect or impair any such
              remedies, powers or rights in respect of any default.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              UNDERTAKINGS
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower undertakes to:
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                Immediately notify Access Bank should there be any change in
                circumstances, or any information supplied to the Bank.
              </li>
              <li className={Styles.descThree}>
                Provide the Access with any other information relating to the
                Borrower as the Bank as it may reasonably require from time to
                time.{" "}
              </li>
              <li className={Styles.descThree}>
                Notify Access Bank of all terminal benefits/entitlements
                including but not limited to death-in-service benefits,
                shares/staff investment trust benefit, cooperative society
                contributions, benefits or entitlement due to be credited to the
                Borrower’s account with the Bank, before the disengagement of
                the Borrower from employment.
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              ELECTRONIC COMMUNICATIONS
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower hereby consents to notices, documents and any other
              communications relating to the facility and these terms and
              conditions being sent by Access Bank to the Borrower or made
              available to the Borrower via email or other electronic means
              (including without limitation, an SMS message). The Borrower also
              consents to receiving commercial electronic messages the Bank may
              send from time to time (including SMS messages and email).
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              INFORMATION
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower authorizes Access Bank to share any personal
              information of the Borrower with any third party, including
              without limitation to lenders, credit bureaus, credit reference
              agencies, payment processing agencies, customer service providers
              and collection agencies for any purpose in relation to this
              facility or the Bank’s business functions and activities, which
              include, without limitation, assessing the Borrower’s credit risk
              and ability to repay debts.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              Access Bank reserves the right to request from the Borrower any
              information or document which it may require in relation to this
              facility, including for assessing the Borrower’s loan application,
              identifying the Borrower or for performing all required
              verifications. The Borrower hereby authorizes Access Bank to
              obtain any information about the Borrower that it may require in
              relation to this facility, from any third party and further
              authorize the relevant third party to disclose such information to
              us.
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              That this facility gives the Bank the right to share the
              Customer’s information and/or document (“Data”) with any service
              provide or third party engaged by the Bank to provide any service
              or support to the Bank and/or Customer pursuant to this Facility.
              Consequently, by accepting the facility, the Customer hereby
              consents to the collection, processing, use and transfer of its
              Data, within or outside Nigeria, for the purposes stated herein.
              VARIATION Only Access Bank may vary these terms and conditions at
              any time if it is required or it is advisable for us to do so by
              law or change in market conditions or to maintain our rate of
              return on this facility. Any variation to these terms and
              conditions is binding on the Borrower from the date specified in
              such notice.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              ASSIGNMENT
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              The Borrower shall not assign all or any part of his/her rights,
              title, interest or obligations in the facility to a third party
              without Access Bank’s written permission. The Bank may assign in
              whole or in part, any of its rights, title, interest and
              obligations in the facility without the consent of the Borrower,{" "}
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              NOTICES
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              No communication will be effective until received by the Bank. A
              communication from Access Bank to the Borrower is, however, deemed
              to be received:{" "}
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                In the case of a letter, on the second business day after
                posting;
              </li>
              <li className={Styles.descThree}>
                In the case of electronic communications, on completion of
                transmission to the relevant electronic address provided that if
                such communication is made at a time which is outside ordinary
                business hours, such communications shall be deemed received on
                the next business day. The term “business day” means a day
                (other than a Saturday or Sunday) upon which Banks are open for
                business in Nigeria.
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              TERMINATION
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              These terms and conditions shall remain in force, as long as
              Access Bank remains a creditor of the Borrower, or as long as any
              part of the facility remains outstanding.
            </div>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              MISCELLANEOUS
            </div>
            <ol style={{ paddingLeft: "1.5em" }}>
              <li className={Styles.descThree}>
                Access Bank may pursue its remedies and exercise all powers
                under this facility separately or concurrently.
              </li>
              <li className={Styles.descThree}>
                Time is of the essence in all respects regarding each of the
                Borrower’s obligations with respect to this facility.
              </li>
              <li className={Styles.descThree}>
                All communication to be made pursuant to this Agreement must be
                made in English.{" "}
              </li>
              <li className={Styles.descThree}>
                The illegality, invalidity, or unenforceability of a provision
                of these terms and conditions under any law will not affect the
                legality, validity, or enforceability of other provision of this
                facility.{" "}
              </li>
              <li className={Styles.descThree}>
                These terms and conditions shall be governed and construed in
                accordance with Nigerian law.
              </li>
            </ol>
          </div>

          <div className={Styles.top}>
            <div style={{ fontWeight: "bold" }} className={Styles.descThree}>
              ACKNOWLEDGMENT
            </div>
            <div style={{ paddingTop: "0.2em" }} className={Styles.descThree}>
              I acknowledge that I have read and understood all of the terms and
              conditions as contained herein and agree to be bound by them.
            </div>
          </div>
           */}

          <div
            className={Styles.descThree}
            dangerouslySetInnerHTML={{ __html: sanitizedHtmlTerms }}
          />

          {/* <iframe
            src={sanitizedTerms}
            width="100%"
            height="600px"
            style={{ border: "none" }}
          ></iframe> */}

          {/* <ul className="teme" style={{ listStyleType: "upper-roman" }}>
      {vehicleData?.Terms?.map((item:any, index:any) => (
        <li key={index}>
          <strong>{index === 0 ? item : item}</strong>
        </li>
      ))}
    </ul> */}


          <div className={Styles.rowTerms}>
            <input
              type="checkbox"
              name="checkbox1"
              checked={checkboxes.checkbox1}
              onChange={handleCheckboxChange}
            />
            <div className={Styles.terms}>
              I confirm that I have read and understood the{" "}
              <span style={{ fontWeight: "bold" }}>Terms and conditions</span>{" "}
              for this loan request
            </div>
          </div>
          {/* <div className={Styles.rowTerms}>
            <input
              type="checkbox"
              name="checkbox2"
              checked={checkboxes.checkbox2}
              onChange={handleCheckboxChange}
            />
            <div className={Styles.terms}>
              <span style={{ fontWeight: "bold" }}>
                Accept Business Financial Advisory Service
              </span>{" "}
              I consent to recieving financial advisory services to enhance our
              business financial management
            </div>
          </div> */}
        </div>

        <div style={{ marginLeft: "1em", marginRight: "1em" }}>
          {vehicleData?.TandCUrl && (
            <a
              href={vehicleData.TandCUrl}
              // download="Terms_and_Conditions.pdf"
              target="_blank"
              // rel="noopener noreferrer"
              style={{
                color: "#64b6f7",
                textAlign: "center",
                paddingLeft: "1.5em",
                display: "flex",
                justifyContent: "center",
              }}
              className={Styles.descThree}
            >
              Download Terms and Conditions
            </a>
          )}

       
          <div className={Styles.btnRow}>
            <button onClick={props.goToHistory} className={Styles.btnOutline}>
              DECLINE
            </button>
            <button
              onClick={props.openSuccess}
              className={Styles.btn}
              disabled={isButtonDisabled}
              style={{
                background: isButtonDisabled ? "#CFCFCF" : "",
              }}
            >
              ACCEPT TERMS
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MerchantsVehicleTermsAndCondition;
